import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FaIconNamePipe } from '@cnp/pipes';

/**
 * Reusable inline notice/callout (amber by default) used to warn or inform the user
 * about a contextual detail — e.g. "you still need to buy a ticket" or "times are
 * saved in the selected timezone". Prefer this over hand-rolling a bordered box.
 */
@Component({
  selector: 'app-alert-notice',
  imports: [CommonModule, TranslatePipe, FaIconComponent, FaIconNamePipe],
  templateUrl: './alert-notice.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './alert-notice.component.scss',
})
export class AlertNoticeComponent {
  /** Translation key for the notice text. */
  @Input() public message: string;
  /** Optional interpolation params for the translation (e.g. { name: 'Acme' }). */
  @Input() public messageParams?: Record<string, unknown>;
  /** Font Awesome icon name (e.g. 'fa-ticket'); rendered with the sharp-solid style. */
  @Input() public icon: string = 'fa-circle-info';
  /** Visual variant. Only amber for now, kept extensible for future tones. */
  @Input() public variant: 'amber' = 'amber';
}
